/**
 * Phase 45 Plan 45-08 — task activity timeline read-only query hook.
 *
 * Wraps GET /api/tasks/:taskId/activity (added in this plan). Stable query
 * key ['tasks', taskId, 'activity']. No mutations — write-side audit rows
 * are emitted by their respective domain services (taskAssigneeService,
 * taskAcceptanceService, taskWatcherService — though watcher writes no
 * audit per 45-04 decision).
 */
import { useQuery } from '@tanstack/react-query';
import {
  type TaskActivityEvent,
  fetchTaskActivity,
} from '../services/api/taskActivity';

export const taskActivityQueryKey = (taskId: number) =>
  ['tasks', taskId, 'activity'] as const;

export function useTaskActivity(taskId: number | null) {
  return useQuery<TaskActivityEvent[]>({
    queryKey:
      taskId != null ? taskActivityQueryKey(taskId) : ['tasks', 'noop', 'activity'],
    queryFn: () => fetchTaskActivity(taskId as number),
    enabled: taskId != null,
    staleTime: 30_000,
    refetchOnMount: 'always',
  });
}

export type { TaskActivityEvent };
